import type { VideoOptions, VideoType } from '@Types/Blocks/Video';

import Decorations from '../../_components/Decorations';
import VideoBig from './variants/Big';
import VideoSmall from './variants/Small';

type VideoProps = Omit<VideoType & VideoOptions, 'block_theme'>;

export const Video = (props: VideoProps) => {
	const {
		variant = 'small',
		style,
		ctasStyle,
		context = 'video',
		placement,
		sectionDecoration,
	} = props;

	let previewUrl;
	let src;

	if (props.url) {
		if (props.url.includes('vimeo')) {
			src = props.url.replace('vimeo.com', 'player.vimeo.com/video');
			previewUrl = (
				<iframe
					className='rounded-minos-video-video'
					title={props.title}
					src={src}
					allow='encrypted-media'
					width='100%'
					height='100%'
				></iframe>
			);
		} else if (props.url.includes('youtu')) {
			src = props.url.replace('/shorts/', '/watch?v=');
			src = src.replace('/watch/', '/watch?v=');
			src = src.replace('watch?v=', 'embed/');
			previewUrl = (
				<iframe
					className='rounded-minos-video-video'
					title={props.title}
					src={src + '?rel=0&amp;controls=1&amp;showinfo=0'}
					allow='encrypted-media'
					width='100%'
					height='100%'
				></iframe>
			);
		} else {
			src = props.url.replace('video', 'embed/video');
			previewUrl = (
				<iframe
					className='rounded-minos-video-video'
					title={props.title}
					src={src}
					allow='encrypted-media'
					width='100%'
					height='100%'
				></iframe>
			);
		}
	}

	const videoProps: VideoType = {
		...props,
		context: context,
		previewUrl,
		sectionDecoration: sectionDecoration,
		headingFontClassName: {
			title: 'minos-video-heading-title-font-style tablet:minos-video-heading-title-font-style',
			text: {
				p: 'minos-video-heading-description-font-style tablet:minos-video-heading-description-font-style my-4',
				a: {
					style: 'a',
					btnDecorationElement: ctasStyle?.a?.btnDecorationElement
						? ctasStyle?.a?.btnDecorationElement
						: 'short',
					btnHasIcon: ctasStyle?.a?.btnHasIcon ? ctasStyle?.a?.btnHasIcon : false,
					aClassname: 'minos-video-btn-a text-base tablet:minos-video-btn-a',
				},
				btnPrimary: {
					style: 'primary',
					btnHasIcon: ctasStyle?.primary?.btnHasIcon ? ctasStyle?.primary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.primary?.btnDecorationElement
						? ctasStyle?.primary?.btnDecorationElement
						: 'short',
					primaryClassname: 'minos-video-btn-primary tablet:minos-video-btn-primary my-2 mr-4',
					animation: ctasStyle?.primary?.animation ? ctasStyle?.primary?.animation : 'none',
				},
				btnSecondary: {
					style: 'secondary',
					btnHasIcon: ctasStyle?.secondary?.btnHasIcon ? ctasStyle?.secondary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.secondary?.btnDecorationElement
						? ctasStyle?.secondary?.btnDecorationElement
						: 'short',
					secondaryClassname: 'minos-video-btn-secondary tablet:minos-video-btn-secondary my-2 mr-4',
					animation: ctasStyle?.secondary?.animation ? ctasStyle?.secondary?.animation : 'none',
				},
				btnTertiary: {
					style: 'tertiary',
					btnHasIcon: ctasStyle?.tertiary?.btnHasIcon ? ctasStyle?.tertiary?.btnHasIcon : false,
					btnDecorationElement: ctasStyle?.tertiary?.btnDecorationElement
						? ctasStyle?.tertiary?.btnDecorationElement
						: 'short',
					tertiaryClassname: 'minos-video-btn-tertiary tablet:minos-video-btn-tertiary',
					animation: ctasStyle?.tertiary?.animation ? ctasStyle?.tertiary?.animation : 'none',
				},
			},
		},
	};

	const variations = {
		small: <VideoSmall {...videoProps} />,
		big: <VideoBig {...videoProps} />,
	};

	return (
		<>
			<section className='relative' data-variant={`video-${variant}`} style={style}>
				<Decorations
					isSectionDecorated={sectionDecoration?.isSectionDecorated}
					type={sectionDecoration?.type}
					pathClassName={`${sectionDecoration?.type === 'wave' ? 'fill-minos-video-bg-color' : 'fill-minos-decoration-bubble-left'}`}
					pathClassNameRightCircle={`${sectionDecoration?.type === 'bubble' && 'fill-minos-decoration-bubble-right'}`}
					placement={placement}
				>
					{variations[variant]}
				</Decorations>
			</section>
		</>
	);
};

export default Video;
